/* 图片切换效果组件 */
/* extend =>  iview  Carousel*/
<template>
  <div class="zSwitchimg">
    <Carousel v-model="index" :dots="setting.dots" :arrow="setting.arrow">
      <CarouselItem v-for="(item,index) in imglists" :key="index">
        <div class="demo-carousel">
          <img :style="{'height': imgHeight + 'px'}" :src="ossUrl + item">
        </div>
      </CarouselItem>
    </Carousel>
  </div>
</template>
<script>
export default {
  name: "ZSwitchimg",
  data() {
    return {
      setting: {
        dots: "none",
        arrow: "never"
      }
    };
  },
  props: {
    imgHeight: {
      type: Number,
      default: 500
    },
    ossUrl: {
      type: String,
      default: ""
    },
    index: {
      type: [Number, String],
      default: 0
    },
    imglists: {
      type: Array,
      default: function() {
        return [];
      }
    }
  }
};
</script>
